import { createStorage } from 'persistme'

var appLocalStorage = createStorage('EQMANAGEMENT');

export default appLocalStorage;
